let isScriptLoaded = false;
let scriptLoadPromise: Promise<void> | null = null;

export const loadHubspotScript = (): Promise<void> => {
  if (isScriptLoaded) {
    return Promise.resolve();
  }

  if (scriptLoadPromise) {
    return scriptLoadPromise;
  }

  scriptLoadPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "//js.hsforms.net/forms/embed/v2.js";
    script.charset = "utf-8";
    script.type = "text/javascript";
    script.async = true;

    script.onload = () => {
      isScriptLoaded = true;
      resolve();
    };

    script.onerror = () => {
      scriptLoadPromise = null;
      reject(new Error("Failed to load Hubspot script"));
    };

    document.body.appendChild(script);
  });

  return scriptLoadPromise;
};
